/**
 * The template field type
 *
 * @group ISOBMFF
 *
 * @beta
 */
export const TEMPLATE = 'template';
